// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content___mU8H","center":"Content_center__vAkj3"};